
document.addEventListener("DOMContentLoaded", () => {

    /*
    |--------------------------------------------------------------------------
    | Initialise Booking State
    |--------------------------------------------------------------------------
    */

    if (!window.valetBooking) {
        window.valetBooking = {
            duration: "",
            variantId: "",
            monthlyCost: "",
            minimumQuantity: 1,
            crates: 1,
            sellingPlan: "",
            paymentInterval: "",
            months: 1,
            deliveryDate: "",
            collectionDate: "",
            address: {
                fullName: "",
                phone: "",
                line1: "",
                line2: "",
                unit: "",
                postcode: ""
            }
        };
    }

    const durationInputs = document.querySelectorAll(
        'input[name="valet_duration"]'
    );

    const modal = document.querySelector(
        "[data-valet-subscription-modal]"
    );

    const modalDialog = modal?.querySelector(
        ".valet-subscription-modal__dialog"
    );

    const durationLabel = modal?.querySelector(
        "[data-valet-selected-duration]"
    );

    const errorMessage = modal?.querySelector(
        "[data-valet-subscription-error]"
    );

    const widgetWrap = modal?.querySelector(
        "[data-valet-seal-widget-wrap]"
    );

    const confirmButton = modal?.querySelector(
        "[data-valet-subscription-confirm]"
    );

    const closeControls = modal?.querySelectorAll(
        "[data-valet-subscription-close]"
    ) || [];

    const nextButton = document.querySelector(
        "[data-booking-next]"
    );

    let lastFocusedElement = null;
    let renderSequence = 0;

    /*
    |--------------------------------------------------------------------------
    | Error Handling
    |--------------------------------------------------------------------------
    */

    function showModalError(message) {
        if (!errorMessage) return;

        errorMessage.textContent = message;
        errorMessage.hidden = false;
    }

    function clearModalError() {
        if (errorMessage) {
            errorMessage.textContent = "";
            errorMessage.hidden = true;
        }
    }

    /*
    |--------------------------------------------------------------------------
    | Find Seal's Existing Product Data
    |--------------------------------------------------------------------------
    |
    | Preserve the actual product information generated by Seal.
    | Do not hardcode selling-plan IDs here.
    |
    */

    function getSealSourceTarget() {

        if (!widgetWrap) return null;

        return (
            widgetWrap.querySelector(
                ".sealsubs-target-element.sealsubs-full"
            ) ||
            widgetWrap.querySelector(
                ".sealsubs-target-element[data-product]"
            ) ||
            widgetWrap.querySelector(
                ".sealsubs-target-element[data-product-id]"
            )
        );
    }

    /*
    |--------------------------------------------------------------------------
    | Rebuild Seal Widget for the Selected Variant
    |--------------------------------------------------------------------------
    */

    function renderSealWidgetForVariant(input) {

        if (!modal || !widgetWrap || !input) {
            showModalError(
                "Unable to load the payment options. Please try again."
            );

            return false;
        }

        const variantId = String(
            input.dataset.variantId || input.value || ""
        );

        if (!variantId) {
            showModalError(
                "Please select a storage duration first."
            );

            return false;
        }

        const source = getSealSourceTarget();

        if (!source) {
            console.error(
                "[Valet Subscription] Seal source target not found."
            );

            showModalError(
                "Unable to load subscription options. Please refresh the page."
            );

            return false;
        }

        const productJSON = source.getAttribute(
            "data-product"
        );

        const productId =
            source.dataset.productId || "";

        const handle =
            source.dataset.handle || "";

        const sealAC =
            source.dataset.sealAc || "";

        let product;

        try {
            product = JSON.parse(productJSON || "null");
        } catch (error) {

            console.error(
                "[Valet Subscription] Unable to parse product data.",
                error
            );

            showModalError(
                "Unable to load product subscription data."
            );

            return false;
        }

        if (!product || !Array.isArray(product.variants)) {

            console.error(
                "[Valet Subscription] Product variant data is missing."
            );

            showModalError(
                "Subscription product data is unavailable."
            );

            return false;
        }

        const selectedVariant = product.variants.find(
            variant =>
                String(variant.id) === variantId
        );

        if (!selectedVariant) {

            console.error(
                "[Valet Subscription] Selected variant not found in Seal data.",
                {
                    variantId,
                    handle,
                    productId
                }
            );

            showModalError(
                "The selected storage duration is not available for subscriptions. Please check the product configuration."
            );

            return false;
        }

        console.log(
            "[Valet Subscription] Preparing widget:",
            {
                duration: input.dataset.title,
                variantId,
                productId,
                handle,
                variantPrice: selectedVariant.price,
                sellingPlanAllocations:
                    selectedVariant.selling_plan_allocations
            }
        );

        /*
        |--------------------------------------------------------------------------
        | Create a Fresh Shopify Product Form
        |--------------------------------------------------------------------------
        */

        const form = document.createElement("form");

        form.id = "valet-seal-dynamic-form";
        form.className =
            "valet-subscription-modal__product-form";

        form.action = "/cart/add";
        form.method = "post";

        const variantInput =
            document.createElement("input");

        variantInput.type = "hidden";
        variantInput.name = "id";
        variantInput.value = variantId;

        /*
        |--------------------------------------------------------------------------
        | Create a Fresh Seal Target
        |--------------------------------------------------------------------------
        */

        const shopifyBlock =
            document.createElement("div");

        shopifyBlock.className =
            "shopify-block shopify-app-block";

        const target = document.createElement("div");

        target.className =
            "sealsubs-target-element";

        target.setAttribute(
            "data-seal-extension",
            ""
        );

        target.setAttribute(
            "data-product-id",
            String(productId || product.id || "")
        );

        target.setAttribute(
            "data-product",
            productJSON
        );

        target.setAttribute(
            "data-handle",
            handle
        );

        if (sealAC) {
            target.setAttribute(
                "data-seal-ac",
                sealAC
            );
        }

        shopifyBlock.appendChild(target);

        form.appendChild(variantInput);
        form.appendChild(shopifyBlock);

        /*
        |--------------------------------------------------------------------------
        | Replace the Previous Widget
        |--------------------------------------------------------------------------
        */

        const currentSequence = ++renderSequence;

        widgetWrap.replaceChildren(form);

        clearModalError();

        /*
        |--------------------------------------------------------------------------
        | Refresh Seal After the Fresh Target Is Inserted
        |--------------------------------------------------------------------------
        */

        window.requestAnimationFrame(() => {

            window.setTimeout(() => {

                // Ignore an older render if another duration
                // was selected while it was waiting.
                if (currentSequence !== renderSequence) {
                    return;
                }

                if (
                    window.SealSubs &&
                    typeof window.SealSubs.refresh === "function"
                ) {

                    window.SealSubs.refresh();

                    console.log(
                        "[Valet Subscription] Seal refresh requested.",
                        {
                            duration: input.dataset.title,
                            variantId
                        }
                    );

                } else {

                    console.error(
                        "[Valet Subscription] SealSubs.refresh() is unavailable."
                    );

                    showModalError(
                        "The subscription widget is still loading. Please refresh the page and try again."
                    );
                }

            }, 50);

        });

        return true;
    }

    /*
    |--------------------------------------------------------------------------
    | Open Subscription Modal
    |--------------------------------------------------------------------------
    */

    function openSubscriptionModal(input) {

        if (!modal || !input) return;

        lastFocusedElement = document.activeElement;

        if (durationLabel) {
            durationLabel.textContent =
                input.dataset.title || "Selected duration";
        }

        clearModalError();

        modal.hidden = false;

        modal.setAttribute(
            "aria-hidden",
            "false"
        );

        document.documentElement.classList.add(
            "valet-subscription-modal-open"
        );

        // Create a fresh Seal widget for this exact variant.
        renderSealWidgetForVariant(input);

        window.requestAnimationFrame(() => {
            modalDialog?.focus();
        });
    }

    /*
    |--------------------------------------------------------------------------
    | Close Subscription Modal
    |--------------------------------------------------------------------------
    */

    function closeSubscriptionModal() {

        if (!modal) return;

        modal.hidden = true;

        modal.setAttribute(
            "aria-hidden",
            "true"
        );

        document.documentElement.classList.remove(
            "valet-subscription-modal-open"
        );

        if (
            lastFocusedElement &&
            typeof lastFocusedElement.focus === "function"
        ) {
            lastFocusedElement.focus();
        }
    }

    closeControls.forEach(control => {

        control.addEventListener(
            "click",
            closeSubscriptionModal
        );

    });

    document.addEventListener("keydown", event => {

        if (
            event.key === "Escape" &&
            modal &&
            !modal.hidden
        ) {
            closeSubscriptionModal();
        }

    });

    /*
    |--------------------------------------------------------------------------
    | Read Selected Seal Selling Plan
    |--------------------------------------------------------------------------
    */

    function getSelectedSealPlan() {

        const widget = modal?.querySelector(
            ".sealsubs-container"
        );

        if (!widget) {
            return null;
        }

        const activeGroup = widget.querySelector(
            ".sls-option-container.sls-active"
        );

        const activeSelect = activeGroup?.querySelector(
            'select[name="subs_interval"]'
        );

        if (
            activeSelect &&
            !activeSelect.disabled &&
            activeSelect.value
        ) {

            return {
                sellingPlan: String(activeSelect.value),

                paymentInterval:
                    activeSelect.selectedOptions[0]
                        ?.textContent.trim() || ""
            };

        }

        const hiddenInput = widget.querySelector(
            'input[name="selling_plan"][data-sls-selling_plan]'
        );

        if (hiddenInput?.value) {

            return {
                sellingPlan: String(hiddenInput.value),
                paymentInterval: ""
            };

        }

        return null;
    }

    /*
    |--------------------------------------------------------------------------
    | Handle Duration Selection
    |--------------------------------------------------------------------------
    */

    durationInputs.forEach(input => {

        input.addEventListener("change", () => {

            const section =
                input.closest(".valet-booking") ||
                document;

            // Highlight the selected duration card.
            section
                .querySelectorAll(".valet-duration-card")
                .forEach(card => {

                    card.classList.remove(
                        "valet-duration-card--selected"
                    );

                });

            input
                .closest(".valet-duration-card")
                ?.classList.add(
                    "valet-duration-card--selected"
                );

            const booking = window.valetBooking;

            /*
            |--------------------------------------------------------------------------
            | Update Selected Variant
            |--------------------------------------------------------------------------
            */

            booking.duration =
                input.dataset.title || "";

            booking.variantId =
                input.dataset.variantId || input.value || "";

            booking.monthlyCost =
                input.dataset.price || "";

            booking.months =
                Number(input.dataset.months || 1);

            booking.minimumQuantity =
                Math.max(
                    1,
                    Number(input.dataset.minQuantity || 1)
                );

            /*
            |--------------------------------------------------------------------------
            | Reset Previous Payment Selection
            |--------------------------------------------------------------------------
            |
            | A selling plan chosen for a previous duration must
            | never carry over to the newly selected variant.
            |
            */

            booking.sellingPlan = "";
            booking.paymentInterval = "";

            /*
            |--------------------------------------------------------------------------
            | Enforce Minimum Crate Quantity
            |--------------------------------------------------------------------------
            */

            if (
                !booking.crates ||
                Number(booking.crates) <
                    booking.minimumQuantity
            ) {

                booking.crates =
                    booking.minimumQuantity;

            }

            /*
            |--------------------------------------------------------------------------
            | Update Booking Summary
            |--------------------------------------------------------------------------
            */

            section
                .querySelectorAll(
                    '[data-summary="storage-duration"]'
                )
                .forEach(element => {

                    element.textContent =
                        booking.duration;

                });

            section
                .querySelectorAll(
                    '[data-summary="crate-quantity"]'
                )
                .forEach(element => {

                    element.textContent =
                        booking.crates;

                });

            document.dispatchEvent(
                new CustomEvent("valet:bookingUpdated")
            );

            if (window.exxtraBookingSummary) {

                window.exxtraBookingSummary.updatePricing();

            }

            console.log(
                "[Valet Booking] Duration selected:",
                booking
            );

            /*
            |--------------------------------------------------------------------------
            | Open Modal With the Newly Selected Variant
            |--------------------------------------------------------------------------
            */

            openSubscriptionModal(input);

        });

        /*
        |--------------------------------------------------------------------------
        | Reopen Payment Modal on the Already Selected Card
        |--------------------------------------------------------------------------
        */

        const card = input.closest(
            ".valet-duration-card"
        );

        card?.addEventListener("click", () => {

            window.setTimeout(() => {

                const booking = window.valetBooking;

                if (
                    input.checked &&
                    modal?.hidden &&
                    String(booking?.variantId) ===
                        String(
                            input.dataset.variantId ||
                            input.value
                        )
                ) {

                    openSubscriptionModal(input);

                }

            }, 0);

        });

    });

    /*
    |--------------------------------------------------------------------------
    | Confirm Payment Plan
    |--------------------------------------------------------------------------
    */

    confirmButton?.addEventListener("click", () => {

        const selectedPlan =
            getSelectedSealPlan();

        if (!selectedPlan?.sellingPlan) {

            showModalError(
                "Seal has not loaded a valid payment plan yet. Please wait a moment and try again."
            );

            return;
        }

        if (!selectedPlan.paymentInterval) {

            showModalError(
                "Please select a payment interval before continuing."
            );

            return;
        }

        const booking = window.valetBooking;

        booking.sellingPlan =
            selectedPlan.sellingPlan;

        booking.paymentInterval =
            selectedPlan.paymentInterval;

        clearModalError();

        console.log(
            "[Valet Subscription Confirmed]",
            {
                duration: booking.duration,
                variantId: booking.variantId,
                sellingPlan: booking.sellingPlan,
                paymentInterval: booking.paymentInterval,
                crates: booking.crates
            }
        );

        document.dispatchEvent(
            new CustomEvent("valet:bookingUpdated")
        );

        if (window.exxtraBookingSummary) {

            window.exxtraBookingSummary.updatePricing();

        }

        closeSubscriptionModal();

    });

    /*
    |--------------------------------------------------------------------------
    | Prevent Step 1 From Advancing Without a Payment Plan
    |--------------------------------------------------------------------------
    */

    nextButton?.addEventListener(
        "click",
        event => {

            const selectedInput = document.querySelector(
                'input[name="valet_duration"]:checked'
            );

            if (!selectedInput) {

                event.preventDefault();
                event.stopImmediatePropagation();

                return;

            }

            if (!window.valetBooking.sellingPlan) {

                event.preventDefault();
                event.stopImmediatePropagation();

                openSubscriptionModal(selectedInput);

            }

        },
        true
    );

});
